<nav class="navbar navbar-expand-lg navbar-light bg-white">
  <a class="navbar-brand" href="http://www.gradientai.com">
    <img width="192px" height="52px" border="0" src="assets/new-logo.png">
  </a>
  <button class="navbar-toggler hidden-sm-up" type="button" (click)="isNavbarCollapsed = !isNavbarCollapsed" data-target="#navbarsDefault" aria-controls="navbarsDefault" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div [ngbCollapse]="isNavbarCollapsed" class="collapse navbar-collapse" id="navbarsDefault">
    <ul class="navbar-nav mr-auto">

      <li class="nav-item">
        <a class="nav-link" routerLink="home">Home</a>
      </li>

      <li class="nav-item dropdown" ngbDropdown *appRbacAllow="['admin', 'healthcare']">
        <a class="nav-link dropdown-toggle" id="id01" ngbDropdownToggle>Healthcare Liability</a>
        <div class="dropdown-menu" aria-labelledby="id01" ngbDropdownMenu>
          <a class="dropdown-item" routerLink="healthcare">PLSnapshots</a>
        </div>
      </li>

      <li class="nav-item" *appRbacAllow="['admin', 'acord']">
        <a class="nav-link" routerLink="uw/acord">Acord Submission</a>
      </li>

      <li class="nav-item dropdown" ngbDropdown *appRbacAllow="['admin', 'sales']">
        <a class="nav-link dropdown-toggle" id="id04" ngbDropdownToggle>Visualizations</a>
        <div class="dropdown-menu" aria-labelledby="id04" ngbDropdownMenu>
          <a class="dropdown-item" routerLink="visualizations/gl-ei-top-claims">Same Effort, Better Result</a>
          <a class="dropdown-item" routerLink="visualizations/gl-ei-same-effort">Same Result, Less Effort</a>
        </div>
      </li>

    </ul>

    <ul  class="nav navbar-nav navbar-right">
      <li>
        <a class="nav-link" (click)="auth.login()" *ngIf="!auth.loggedIn">Login</a>
      </li>
    </ul>
    <ul  class="nav navbar-nav navbar-right">
      <li>
        <a class="nav-link" (click)="auth.logout()" *ngIf="auth.loggedIn">Logout</a>
      </li>
    </ul>

  </div>
</nav>
